import { $color_grey_8, $color_grey_9 } from '../pebbleGlobalToken/color.js';
import { $spacing_s2 } from '../pebbleGlobalToken/spacing.js';

/**
 * Steps-用于原点的宽、高、行高等尺寸数字
 * @description enDesc: -
 * @description type: Font
 * @description value: $line_height_5
 */
var $steps_width_height = 28;

/**
 * Steps-用于dot圆点的宽、高、行高等尺寸数字
 * @description enDesc: -
 * @description type: Space
 * @description value: $spacing_s2
 */
var $steps_dot_width_height = $spacing_s2;

/**
 * Steps-用于dot圆点的宽、高、行高等尺寸数字(active)
 * @description enDesc: -
 * @description type: Space
 * @description value: 10
 */
var $steps_dot_active_width_height = 10;

/**
 * Steps-用于已完成标题颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: color-grey-8
 */
var $steps_finish_text_color = $color_grey_8;

/**
 * Steps-用于未完成标题颜色
 * @description enDesc: -
 * @description type: Color
 * @description value: color-grey-9
 */
var $steps_unfinish_text_color = $color_grey_9;

/**
 * Steps-用于process圆环外环的宽、高等尺寸数字
 * @description enDesc: -
 * @description type: Space
 * @description value: 44px
 */
var $steps_process_circle_width = 44;

/**
 * Steps-用于process圆环数字的insetStart
 * @description enDesc: -
 * @description type: Space
 * @description value: -9px
 */
var $steps_process_inset_start = -9;

export { $steps_dot_active_width_height, $steps_dot_width_height, $steps_finish_text_color, $steps_process_circle_width, $steps_process_inset_start, $steps_unfinish_text_color, $steps_width_height };
